import { Component } from '@angular/core';

// Rxjs dependencies
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

// Store
import { Store } from '@ngrx/store';
import { AppState, selectLevel } from '../../store.module';

// App dependencies.
import { Creep } from '../../creep';

@Component({
  selector: 'app-power-resource-needed',
  templateUrl: './power-resource-needed.component.html',
  styleUrls: ['./power-resource-needed.component.scss']
})
export class PowerResourceNeededComponent {
  public powerNeeded$: Observable<number>;

  constructor(
    private _store: Store<AppState>
  ) {
    this.powerNeeded$ = this._store
      .select(selectLevel)
      .map(this.powerResourceNeededCalc);
  }

  powerResourceNeededCalc(level): number {
    let sum = 0;

    for (let i = 0; i <= level; i++) {
      const pow = Math.pow(i, 1.15) * 1000;
      sum += Math.round(pow);
    }

    return sum;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/power-resource-needed.component/power-resource-needed.component.ts